import { paymentService } from "../../service/payment"
import { createLoadingSelector } from "./Loading"

const GET_PAYMENT_URL = "GET_PAYMENT_URL"
const GET_PAYMENT_URL_REQUEST = "GET_PAYMENT_URL_REQUEST"
const GET_PAYMENT_URL_SUCCESS = "GET_PAYMENT_URL_SUCCESS"
const GET_PAYMENT_URL_FAILURE = "GET_PAYMENT_URL_FAILURE"

const PAYMENT_VERIFICATION = "PAYMENT_VERIFICATION"
const PAYMENT_VERIFICATION_REQUEST = "PAYMENT_VERIFICATION_REQUEST"
const PAYMENT_VERIFICATION_SUCCESS = "PAYMENT_VERIFICATION_SUCCESS"
const PAYMENT_VERIFICATION_FAILURE = "PAYMENT_VERIFICATION_FAILURE"

const PAYMENT_EGIFT_VERIFICATION = "PAYMENT_EGIFT_VERIFICATION"
const PAYMENT_EGIFT_VERIFICATION_REQUEST = "PAYMENT_EGIFT_VERIFICATION_REQUEST"
const PAYMENT_EGIFT_VERIFICATION_SUCCESS = "PAYMENT_EGIFT_VERIFICATION_SUCCESS"
const PAYMENT_EGIFT_VERIFICATION_FAILURE = "PAYMENT_EGIFT_VERIFICATION_FAILURE"

const initialState = {
	getPaymentUrlErrorMessage: "",
	getPaymentUrlSuccessMessage: "",
	paymentVerificationErrorMessage: "",
	paymentVerificationSuccessMessage: "",
	paymentRequestUrl: {},
	paymentVerification: {},
	transactType: "", // "EGIFT" or "TOPUP"
}

export const getPaymentUrlLoadingSelector = createLoadingSelector([GET_PAYMENT_URL])

export const paymentVerificationLoadingSelector = createLoadingSelector([
	PAYMENT_VERIFICATION,
])
export const paymentEgiftVerificationLoadingSelector = createLoadingSelector([
	PAYMENT_EGIFT_VERIFICATION,
])
export const paymentVerification = (d) => (dispatch, getState) => {
	return dispatch({
		types: [
			PAYMENT_VERIFICATION_REQUEST,
			PAYMENT_VERIFICATION_SUCCESS,
			PAYMENT_VERIFICATION_FAILURE,
		],
		callAPI: (config) => paymentService.verifyGatewayResponse(d, config),
		payload: d,
	})
}

export const paymentEgiftVerification = (d) => (dispatch, getState) => {
	return dispatch({
		types: [
			PAYMENT_EGIFT_VERIFICATION_REQUEST,
			PAYMENT_EGIFT_VERIFICATION_SUCCESS,
			PAYMENT_EGIFT_VERIFICATION_FAILURE,
		],
		callAPI: (config) => paymentService.verifyGatewayResponse(d, config),
		payload: d,
	})
}

export default function reducer(state = initialState, action) {
	const {
		payload,
		errorMessage,
		successMessage,
		getPaymentUrlSuccessMessage,
		getPaymentUrlErrorMessage,
		paymentVerificationSuccessMessage,
		paymentVerificationErrorMessage,
	} = action
	switch (action.type) {
		case GET_PAYMENT_URL_REQUEST:
			return {
				...state,
				getPaymentUrlErrorMessage: errorMessage,
				getPaymentUrlSuccessMessage: successMessage,
			}
		case GET_PAYMENT_URL_SUCCESS:
			return {
				...state,
				getPaymentUrlpaymentRequestUrl: payload,
				getPaymentUrlSuccessMessage: successMessage,
			}
		case GET_PAYMENT_URL_FAILURE:
			return { ...state, getPaymentUrlErrorMessage: errorMessage }
		case PAYMENT_VERIFICATION_REQUEST:
			return {
				...state,
				paymentVerificationErrorMessage: "",
				paymentVerificationSuccessMessage: "",
			}
		case PAYMENT_VERIFICATION_SUCCESS: {
			if (payload.status === "FAILED" && payload.isRejectedByAntiFraud) {
				return {
					...state,
					paymentVerification: { ...payload },
					paymentVerificationErrorMessage: "cardPurchaseDetail.error.fraud",
					paymentVerificationSuccessMessage: successMessage,
				}
			}
			return {
				...state,
				paymentVerification: { ...payload },
				paymentVerificationSuccessMessage: successMessage,
			}
		}
		case PAYMENT_VERIFICATION_FAILURE:
			return { ...state, paymentVerificationErrorMessage: errorMessage }

		case PAYMENT_EGIFT_VERIFICATION_REQUEST:
			return {
				...state,
				paymentVerificationErrorMessage: "",
				paymentVerificationSuccessMessage: "",
			}
		case PAYMENT_EGIFT_VERIFICATION_SUCCESS: {
			if (payload.status === "FAILED" && payload.isRejectedByAntiFraud) {
				return {
					...state,
					paymentVerification: { ...payload },
					paymentVerificationErrorMessage: "egiftPurchaseDetail.error.fraud",
					paymentVerificationSuccessMessage: successMessage,
				}
			}
			return {
				...state,
				paymentVerification: { ...payload },
				paymentVerificationSuccessMessage: successMessage,
			}
		}
		case PAYMENT_EGIFT_VERIFICATION_FAILURE:
			return { ...state, paymentVerificationErrorMessage: errorMessage }
		default:
			return state
	}
}
